import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AppNavbar from "./components/Navbar";
import HeroCarousel from "./components/HeroCarousel";
import Services from "./components/Services";
import LeadForm from "./components/Leadform";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import { AboutSection, PrivacySection } from "./components/ExtraSections";
import ServicioDetalle from "./components/ServicioDetalle";
import useSmoothScroll from "./components/SmoothScroll";

function App() {
  useSmoothScroll();

  return (
    <Router>
      <AppNavbar />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <HeroCarousel />
              <AboutSection />
              <Services />
              <LeadForm />
              <PrivacySection />
              <Footer />
              <WhatsAppButton />
            </>
          }
        />
        <Route path="/servicios/:nombre" element={<ServicioDetalle />} />
      </Routes>
    </Router>
  );
}

export default App;
